module.exports = __webpack_public_path__ + "3e1ef284637458c46aca815dec114215.jpg";